import Vue from 'vue';
import { loader } from "../utils";
import Api from '@plugins/api';
import repositories from '../api/home';
Vue.use(Api, {repositories, baseUrl: process.env.MIX_CANDIDATE_API_URL});

export default {
  data() {
    return {
      searchFormLoaded: false,
      searchJobLoaded: false,
      occupations: [],
      languages: [],
      locations: [],
      initialValues: [],
      infoOccupations: [],
      infoIndustries: [],
      infoLocations: [],
      infoLanguages: [],
      infoFeatures: [],
    }
  },
  methods: {
    showModal: function(event) {
      if (!this.searchFormLoaded) {
        const $vm = this;
        const modalId = event.currentTarget.getAttribute('data-target');
        loader(true);

        $vm.$repository("search-form").getInfo(process.env.MIX_CANDIDATE_API_URL + '/api/info/search-form')
        .then(res => {
          $vm.occupations = res.occupations;
          $vm.languages = res.languages;
          $vm.locations = res.locations;
          loader(false);
          $(modalId).modal('toggle');
        }).catch(err => {
          loader(false);
        });

        $vm.searchFormLoaded = true;
      }
    },
    searchJob: function(event) {
      if (!this.searchJobLoaded) {
        const $vm = this;
        const modalId = event.currentTarget.getAttribute('data-target');
        loader(true);

        $vm.$repository("search-job").getInfo(process.env.MIX_CANDIDATE_API_URL + '/api/info/search-job')
        .then(res => {
          $vm.initialValues = res.initial_values;
          $vm.infoOccupations = res.info_occupations;
          $vm.infoIndustries = res.info_industries;
          $vm.infoLocations = res.info_locations;
          $vm.infoLanguages = res.info_languages;
          $vm.infoFeatures = res.info_features;
          setTimeout(function () {
            loader(false);
            $(modalId).modal('toggle');
          }, 200);
        }).catch(err => {
          loader(false);
        });

        $vm.searchJobLoaded = true;
      }
    }
  },
}
